



import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const RangeChart = ({ ranges }) => {

  const [chartState, setChartState] = useState({
    series: [],
    options: {
      chart: {
        type: 'donut',
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val.toFixed(2) + "%";
        },
        textAnchor: 'middle',
        distributed: false,
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          colors: undefined
        },
        background: {
          enabled: true,
          foreColor: '#fff', 
          padding: 5,
          borderRadius: 2,
          borderWidth: 1,
          borderColor: '#fff',
          opacity: 0.9,
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.45
          }
        },
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: '#000',
          opacity: 0.45
        }
      },
      colors: ['#5972FF', '#31BACC', '#3e4095', '#333333'],
      labels: ['Time Weightage', 'Error Weightage', 'Critical Weightage', 'Quiz Weightage'],
      legend: {
        fontSize: '16px',
        fontWeight: "500",
        fontFamily: "Poppins', sans-serif",
        padding: "0 5px" 
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }
  });

  useEffect(() => {
    if (ranges && ranges.length > 0) {
      const series = ranges.map(range => parseInt((range.value) * 100));
      const seriesName = ranges.map(range => `${range.key} Weightage` );
      setChartState(prevState => ({
        series,
        options:{
          ...prevState.options,
          labels:seriesName
        }
      }));
    }
  }, [ranges]);

  return (
   <>
      <div id="chart" style={{ maxWidth: "550px" }}>
        <ReactApexChart width='550px' height='300px' options={chartState.options} series={chartState.series} type="donut" />
      </div>
      </>
  );
};

export default RangeChart;
